<template>
  <div id="app">
    <transition name="fade" mode="out-in">
    　　<router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
  // data() {
  //     return {
  //       url: '',
  //       fade: 'fade-enter-active'//默认动画
  //     };
  // }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}



.fade-enter {
   　　 opacity: 0;
}
.fade-leave{
    　　opacity: 1;
}
.fade-leave-active,.fade-enter-active {
 　　　　transition:opacity 0.8s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue